export const TYPES = {
  LASTNAME: 'lastname',
  FIRSTNAME: 'firstname',
  SSN: 'ssn',
  DATE: 'date',
}
